import React from "react";
import { Link } from "react-router-dom";
import { FixyBeeMark } from "./FixyBeeMark";

/**
 * The lockup: ZIPPY plus the wordmark.
 *
 * PORT NOTE (DY1.4): the design system renders a bare `<a href="#">` because it
 * ships without a router. Here it is a react-router `Link` so the header logo
 * does a client-side navigation instead of a full reload — and `to` is a prop so
 * an inverse footer lockup can point somewhere else.
 */
export function Logo({ size = 36, withWordmark = true, inverse = false, to = "/", src, style = {}, ...rest }) {
  const [hover, setHover] = React.useState(false);
  return (
    <Link
      to={to}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{ display: "inline-flex", alignItems: "center", gap: "10px", textDecoration: "none", ...style }}
      data-testid="logo-link"
      /* Without the wordmark this link is a bare SVG, so it reaches a screen
         reader as an unnamed link — and on the Dany thread it is the way out. */
      aria-label={withWordmark ? undefined : "FixyDany"}
      {...rest}
    >
      <span style={{
        display: "inline-flex",
        transform: hover ? "rotate(-8deg)" : "rotate(0)",
        transition: "transform var(--duration-slow) var(--ease-out)",
      }}>
        <FixyBeeMark size={size} src={src} />
      </span>
      {withWordmark && (
        <span style={{
          fontFamily: "var(--font-display)", fontWeight: "var(--weight-extrabold)",
          fontSize: "var(--text-xl)", letterSpacing: "var(--tracking-tight)",
          color: inverse ? "var(--text-inverse)" : "var(--text-body)",
        }}>
          Fixy<span style={{ color: inverse ? "var(--hive)" : "var(--text-accent)" }}>Dany</span>
        </span>
      )}
    </Link>
  );
}

export default Logo;
